/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Cpf_Cnpj_PlaceholderInputs */

const en_clients_field_cpf_cnpj_placeholder = /** @type {(inputs: Clients_Field_Cpf_Cnpj_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPF or CNPJ`)
};

const pt_br2_clients_field_cpf_cnpj_placeholder = /** @type {(inputs: Clients_Field_Cpf_Cnpj_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPF ou CNPJ`)
};

/**
* | output |
* | --- |
* | "CPF or CNPJ" |
*
* @param {Clients_Field_Cpf_Cnpj_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_cpf_cnpj_placeholder = /** @type {((inputs?: Clients_Field_Cpf_Cnpj_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Cpf_Cnpj_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_cpf_cnpj_placeholder(inputs)
	return pt_br2_clients_field_cpf_cnpj_placeholder(inputs)
});